import React from 'react';
import { THUMB_CDN, THUMB_GAMES, NEW_LAUNCH } from '../../data/homeData';

/* Mobile-only homepage thumb-grid — the real reference block:
   .game-slider.mb-2 > .coupon-card > [ .custom-thumb-section (2-row scroll grid),
   h2.ipl "new launch", .top-baner (banner carousel) ].
   Hidden on desktop via the .reddy-thumb-only wrapper (display:none >991px) so the
   desktop homepage is unchanged (cricket table first). The custom-thumb-section's
   own display:none→grid @media mirrors the reference.

   All thumbnails are live-server assets (speedcdn.io/frontend_config/tiger/images/*),
   which don't load off the live server → onError falls back to a local slug asset,
   then to the crimson gradient + game-name placeholder underlay. */

/* two-step onError: live CDN → local /images/reddy/thumbs/{slug}.gif → hide (reveal underlay) */
const onThumbError = (e, localSrc) => {
  const img = e.currentTarget;
  if (!img.dataset.triedLocal && localSrc) {
    img.dataset.triedLocal = '1';
    img.src = localSrc;
  } else {
    img.style.display = 'none'; // reveal the gradient+name placeholder underneath
  }
};

function Thumb({ game }) {
  const live = game.img ? `${THUMB_CDN}/${game.img}` : '';
  return (
    <div className="cts-img popularDiv hc_div">
      <span className="cts-thumb-ph">{game.name}</span>
      {live && (
        <img
          className="img-fluid"
          src={live}
          alt={game.name}
          loading="lazy"
          onError={(e) => onThumbError(e, `/images/reddy/thumbs/${game.slug}.gif`)}
        />
      )}
    </div>
  );
}

function BannerSlide({ game }) {
  const live = game.img ? `${THUMB_CDN}/${game.img}` : '';
  return (
    <div className="swiper-slide slider_banner__item">
      <span className="banner-ph">{game.name}</span>
      {live && (
        <img
          className="img-fluid slider_banner__item_img"
          src={live}
          alt={game.name}
          loading="lazy"
          onError={(e) => onThumbError(e, `/images/reddy/thumbs/${game.slug}.png`)}
        />
      )}
    </div>
  );
}

export default function GameThumbGrid() {
  return (
    <div className="game-slider mb-2 reddy-thumb-only">
      <div className="coupon-card">
        {/* 2-row horizontal-scroll grid of game thumbnails */}
        <div className="custom-thumb-section">
          {THUMB_GAMES.map((g) => <Thumb key={g.slug} game={g} />)}
        </div>

        {/* NEW LAUNCH title (reference: mobile-only .col-12.px-0.d-block.d-md-none) */}
        <div className="col-12 px-0 d-block d-md-none">
          <h2 className="ipl">new launch</h2>
        </div>

        {/* NEW LAUNCH banner carousel (top-baner swiper → static scroll strip) */}
        <div className="top-baner">
          <div className="reddy-banner-strip">
            {NEW_LAUNCH.map((g) => <BannerSlide key={g.slug} game={g} />)}
          </div>
        </div>
      </div>
    </div>
  );
}
